import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "./tp-studio-header";
import TPStudioSidebar from "./TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/CardsSprite.css";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";

import spriteUrl from "../../../assets/topstudio/styles/svg/sprite.css-d6f47756.svg";

import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import BetfairCasinoBetslipWeb from "../betfair-games/betfair_casino_betslip_web";
import axiosInstance from "../../../utils/axiosInstance";
import HighCardResult from "../../client/tp-studio/tp-result/HighCardResult.jsx";
import { isMobile } from "react-device-detect";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import HighCardRules from "./pop-up/highcard-rules.jsx";
import Volume from "./Volume";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function HighCardVirtual() {
  const [stakeLimit, setStakeLimit] = useState(0);

  const dispatch = useDispatch();
  const TOTAL_SECONDS = 30;
  const [showRules, setShowRules] = useState(false);
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);
  const [isNarrowViewport, setIsNarrowViewport] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 768
  );
  const useMobileBetSlip = isMobile || isNarrowViewport;
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [resultList, setResultList] = useState([]);
  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);

  const [open, setOpen] = useState(false);
  const [gameRoundId, setGameRoundId] = useState("");
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});

  const [book1, setBook1] = useState("");
  const [book2, setBook2] = useState("");
  const [book3, setBook3] = useState("");
  const [book4, setBook4] = useState("");
  const [book5, setBook5] = useState("");
  const [book6, setBook6] = useState("");
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);
  ///
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "virtual",
    type: "highcard_virtual"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;

  //console.log("Socket:", payload);

  let cardNum1 = 0;
  let cardNum2 = 0;
  let cardNum3 = 0;
  let cardNum4 = 0;
  let resultCardNo = 0;

  const [roundId, setRoundId] = useState("");
  const [eventStatus, setEventStatus] = useState("");
  const [timeLeftGame, setLimeLeftGame] = useState("");
  const [suspend1, setSuspend1] = useState(0);
  const [suspend2, setSuspend2] = useState(0);
  const [suspend3, setSuspend3] = useState(0);
  const [suspend4, setSuspend4] = useState(0);
  const [suspend5, setSuspend5] = useState(0);
  const [suspend6, setSuspend6] = useState(0);

  const [winnerplayer1, setWinnerplayer1] = useState(false);
  const [winnerplayer2, setWinnerplayer2] = useState(false);
  const [winnerplayer3, setWinnerplayer3] = useState(false);
  const [winnerplayer4, setWinnerplayer4] = useState(false);
  const [winnerplayer5, setWinnerplayer5] = useState(false);
  const [winnerplayer6, setWinnerplayer6] = useState(false);

  const [b1, setB1] = useState(0);
  const [b2, setB2] = useState(0);
  const [b3, setB3] = useState(0);
  const [b4, setB4] = useState(0);
  const [b5, setB5] = useState(0);
  const [b6, setB6] = useState(0);

  const [l1, setL1] = useState(0);
  const [l2, setL2] = useState(0);
  const [l3, setL3] = useState(0);
  const [l4, setL4] = useState(0);
  const [l5, setL5] = useState(0);
  const [l6, setL6] = useState(0);

  const [c1, seC1] = useState("");
  const [c2, seC2] = useState("");
  const [c3, seC3] = useState("");
  const [c4, seC4] = useState("");

  const [c1Img, setC1Img] = useState("");
  const [c2Img, setC2Img] = useState("");
  const [c3Img, setC3Img] = useState("");
  const [c4Img, setC4Img] = useState("");
  const [c5Img, setC5Img] = useState("");
  const [c6Img, setC6Img] = useState("");

  const [cards_desc, setCardsDesc] = useState("");
  const [lastStatus, setLastStatus] = useState(null);

  /* ================= SEQUENTIAL CARD REVEAL ================= */
  const lastEvtStatusRef = useRef(null);
  const flipTimerRef = useRef(null);
  const [shownC1, setShownC1] = useState("");
  const [shownC2, setShownC2] = useState("");
  const [shownC3, setShownC3] = useState("");
  const [shownC4, setShownC4] = useState("");
  const [shownC5, setShownC5] = useState("");
  const [shownC6, setShownC6] = useState("");
  const [cardsSettled, setCardsSettled] = useState(false);
  const cardsSettleTimerRef = useRef(null);

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payload) return;
    setDisplayLoader(false);
    updateUserData(data?.user);

    if (lastStatus != payload.evt_status && payload.evt_status === "OPEN") {
      //setPlacedBets([]); //clearing placed bets on status change
      setWinnerplayer1(false);
      setWinnerplayer2(false);
      setWinnerplayer3(false);
      setWinnerplayer4(false);
      setWinnerplayer5(false);
      setWinnerplayer6(false);
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
    }
    if (lastStatus != payload.evt_status) {
      setLastStatus(payload.evt_status);
    }

    setRoundId(payload?.cat_mid);
    setEventStatus(payload?.evt_status);
    setSuspend1(payload?.suspend1);
    setSuspend2(payload?.suspend2);
    setSuspend3(payload?.suspend3);
    setSuspend4(payload?.suspend4);
    setSuspend5(payload?.suspend5);
    setSuspend6(payload?.suspend6);

    let timeLeftGame1 = payload?.left_time;
    if (timeLeftGame1 == 1) {
      timeLeftGame1 = 0;
    }
    timeLeftGame1 = parseInt(timeLeftGame1);
    setLimeLeftGame(timeLeftGame1);

    // sync SVG timer with server value and start local countdown
    const serverTime = timeLeftGame1;
    setTimeLeft(serverTime);
    if (localTimerRef.current) clearInterval(localTimerRef.current);
    if (serverTime > 0) {
      let t = serverTime;
      localTimerRef.current = setInterval(() => {
        t -= 1;
        setTimeLeft(t <= 0 ? 0 : t);
        if (t <= 0) clearInterval(localTimerRef.current);
      }, 1000);
    }

    setB1(payload?.b1);
    setB2(payload?.b2);
    setB3(payload?.b3);
    setB4(payload?.b4);
    setB5(payload?.b5);
    setB6(payload?.b6);

    setL1(payload?.l1);
    setL2(payload?.l2);
    setL3(payload?.l3);
    setL4(payload?.l4);
    setL5(payload?.l5);
    setL6(payload?.l6);

    seC1(payload.c1 == 1 ? 0 : payload.c1);
    seC2(payload.c2 == 1 ? 0 : payload.c2);
    seC3(payload.c3 == 1 ? 0 : payload.c3);
    seC4(payload.c4 == 1 ? 0 : payload.c4);

    let cards_desc = payload?.cards_desc;
    setCardsDesc(cards_desc);

    if (cards_desc) {
      let cardsDesc = cards_desc.split(",");
      setC1Img(cardsDesc[0]);
      setC2Img(cardsDesc[1]);
      setC3Img(cardsDesc[2]);
      setC4Img(cardsDesc[3]);
      setC5Img(cardsDesc[4]);
      setC6Img(cardsDesc[5]);
    }
    if (payload?.result != "") {
      setWinnerplayer1(false);
      setWinnerplayer2(false);
      setWinnerplayer3(false);
      setWinnerplayer4(false);
      setWinnerplayer5(false);
      setWinnerplayer6(false);

      if (payload?.result == 1) {
        setWinnerplayer1(true);
      } else if (payload?.result == 2) {
        setWinnerplayer2(true);
      } else if (payload?.result == 3) {
        setWinnerplayer3(true);
      } else if (payload?.result == 4) {
        setWinnerplayer4(true);
      } else if (payload?.result == 5) {
        setWinnerplayer5(true);
      } else if (payload?.result == 6) {
        setWinnerplayer6(true);
      }
    } else {
      setWinnerplayer1(false);
      setWinnerplayer2(false);
      setWinnerplayer3(false);
      setWinnerplayer4(false);
      setWinnerplayer5(false);
      setWinnerplayer6(false);
    }

    return () => {
      if (localTimerRef.current) clearInterval(localTimerRef.current);
    };
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => {
    if (!payload?.evt_status) return;
    if (lastEvtStatusRef.current === payload.evt_status) return;

    lastEvtStatusRef.current = payload.evt_status;
    clearTimeout(flipTimerRef.current);

    if (payload.evt_status === "OPEN") {
      setShownC1("");
      setShownC2("");
      setShownC3("");
      setShownC4("");
      setShownC5("");
      setShownC6("");
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    if (payload.evt_status === "CLOSED") {
      const raw = payload?.cards_desc;
      if (!raw) return;
      const cards = raw.split(",");

      setShownC1("");
      setShownC2("");
      setShownC3("");
      setShownC4("");
      setShownC5("");
      setShownC6("");

      const setters = [
        setShownC1,
        setShownC2,
        setShownC3,
        setShownC4,
        setShownC5,
        setShownC6
      ];
      let pos = 0;
      let cancelled = false;

      function revealNext() {
        if (cancelled || pos >= cards.length) return;
        const card = cards[pos];
        if (card && card !== "1") setters[pos](card);
        pos++;
        if (pos < cards.length) {
          flipTimerRef.current = setTimeout(revealNext, 1000);
        }
      }

      flipTimerRef.current = setTimeout(revealNext, 300);

      return () => {
        cancelled = true;
        clearTimeout(flipTimerRef.current);
      };
    }
  }, [payload?.evt_status]);

  useEffect(() => {
    const cards = cards_desc ? cards_desc.split(",") : [];
    const shownList = [shownC1, shownC2, shownC3, shownC4, shownC5, shownC6];
    const allRevealed =
      cards.length > 0 &&
      cards.every((card, i) => !card || card === "1" || shownList[i] === card);

    if (!allRevealed) {
      setCardsSettled(false);
      clearTimeout(cardsSettleTimerRef.current);
      return;
    }

    clearTimeout(cardsSettleTimerRef.current);
    cardsSettleTimerRef.current = setTimeout(() => {
      setCardsSettled(true);
    }, 1000);

    return () => clearTimeout(cardsSettleTimerRef.current);
  }, [cards_desc, shownC1, shownC2, shownC3, shownC4, shownC5, shownC6]);

  useEffect(
    () => () => {
      clearTimeout(flipTimerRef.current);
      clearTimeout(cardsSettleTimerRef.current);
    },
    []
  );

  const getResultDisplayName = (value) => String(value ?? "-");

  function splitCards(imgData) {
    let imgVal = imgData.split("");
    let resultCardVal = imgVal[0];
    if (resultCardVal == "J") {
      resultCardVal = 11;
    }
    if (resultCardVal == "Q") {
      resultCardVal = 12;
    }
    if (resultCardVal == "K") {
      resultCardVal = 13;
    }
    return (resultCardNo = parseInt(resultCardVal));
  }

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /// place bet ///

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const showBetfairBetSlip = (bettype, teamname, price) => {
    if (!price || price <= 0) return;
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "highcard_virtual"
    };
    placeBetObject.catmid = roundId;
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.game_type = 7;

    setPlaceBetObject(placeBetObject);
    setBetErrorMessage({});
    if (useMobileBetSlip) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const placeBet = async (amount, profit) => {
    if (!profit) {
      profit = 0;
    }
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;

    //console.log("[HighCard] placing bet:", placeBetObject);
    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );
      //console.log("[HighCard] bet response:", response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        getBook();
        setShowBetSlipPopup(false);
      }
    } catch (error) {
      let messageObj = {
        status: false,
        message: "An error occurred. Please try again."
      };
      const data = error?.response?.data;
      if (data) {
        if (data.message) {
          messageObj.message = data.message;
        } else if (data.error) {
          messageObj.message = data.error;
        }
      }
      setBetErrorMessage(messageObj);
    }
  };

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsNarrowViewport(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId; // roundId;
    bookObject.game_type = "highcard-virtual";
    //console.log(roundId);
    const response = await axiosInstance.post("/tp20-book", bookObject);
    //console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let bet_list = response.data.bets_list;
    if (userbook.length > 0) {
      let book1Val = userbook[0].rnr1s;
      let book2Val = userbook[0].rnr2s;
      let book3Val = userbook[0].rnr3s;
      let book4Val = userbook[0].rnr4s;
      let book5Val = userbook[0].rnr5s;
      let book6Val = userbook[0].rnr6s;

      setBook1(book1Val);
      setBook2(book2Val);
      setBook3(book3Val);
      setBook4(book4Val);
      setBook5(book5Val);
      setBook6(book6Val);
    } else {
      setBook1("");
      setBook2("");
      setBook3("");
      setBook4("");
      setBook5("");
      setBook6("");
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  ); // Empty dependency array
  /// place bet ///

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "highcard_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);
  //console.log("roundId:", roundId);

  return (
    <div className="highcard-virtual-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row highcard-game-row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-12 col-md-8">
                      <div className="left-content">
                        <div>
                          {" "}
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>HIGH CARD</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div
                              className="cards-layout blackjack"
                              style={{ position: "relative" }}
                            >
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <HighCardRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />

                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          53
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div className="three-cards-wrapper">
                                <span
                                  id="AlltabData"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div
                                    id="videos"
                                    class="collapse show desktop mobile highcard-gradient highcard-players-stage"
                                    aria-labelledby="headingThree"
                                    data-parent="#video"
                                    style={{
                                      textAlign: "center",
                                      padding: "0px",
                                      position: "relative",
                                      paddingBottom: "24px"
                                    }}
                                  >
                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 1</span>
                                        <div
                                          class={`player-card ${winnerplayer1 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards1"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView"
                                                class="card1"
                                              >
                                                {shownC1 && shownC1 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC1}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 2</span>
                                        <div
                                          class={`player-card ${winnerplayer2 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards2"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView"
                                                class="card1"
                                              >
                                                {shownC2 && shownC2 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC2}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 3</span>
                                        <div
                                          class={`player-card ${winnerplayer3 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards3"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView2"
                                                class="card1"
                                              >
                                                {shownC3 && shownC3 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC3}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 4</span>
                                        <div
                                          class={`player-card ${winnerplayer4 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards4"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView2"
                                                class="card1"
                                              >
                                                {shownC4 && shownC4 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC4}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 5</span>
                                        <div
                                          class={`player-card ${winnerplayer5 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards5"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView2"
                                                class="card1"
                                              >
                                                {shownC5 && shownC5 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC5}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="player">
                                      <div class="player-item">
                                        <span class="name">Player 6</span>
                                        <div
                                          class={`player-card ${winnerplayer6 && cardsSettled
                                              ? "won"
                                              : "stood"
                                            }`}
                                          style={{
                                            backgroundColor:
                                              "rgba(255, 255, 255, 0.3)"
                                          }}
                                        >
                                          <div class="header-title">
                                            <span class="status"></span>
                                          </div>
                                          <div
                                            id="BFBCardHandView"
                                            class="BFBCardHandView"
                                          >
                                            <div
                                              id="game-cards6"
                                              class="BFBCardFanView"
                                            >
                                              <div
                                                id="BFBCardView2"
                                                class="card1"
                                              >
                                                {shownC6 && shownC6 !== "1" && (
                                                  <img
                                                    id="RSMImageView"
                                                    src={`../assets/galaxy/img/cards3/${shownC6}.svg`}
                                                    class="RSMImageView animate__animated animate__flipInY"
                                                  />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </span>
                              </div>

                              <Volume
                                id="HighCardSoundcontrol"
                                style={{
                                  position: "absolute",
                                  right: 8,
                                  bottom: 8,
                                  zIndex: 100,
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              />
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList)
                                .slice(
                                  0,
                                  isNarrowViewport
                                    ? 5
                                    : Object.keys(resultList).length
                                )
                                .map((key) => (
                                  <button
                                    key={key}
                                    className="video-button border-gradient-btn border-gradient-purple-btn"
                                  >
                                    {getResultDisplayName(resultList[key])}
                                  </button>
                                ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content highcard-market-board"
                            style={{ background: "#fff" }}
                          >
                            <div class="market-titlebar">
                              <p class="market-name">
                                <span class="market-name-badge">
                                  <i class="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MAIN </span>
                                </span>
                              </p>
                              <div class="market-overarround">
                                <span></span>
                                <strong>Back</strong>
                              </div>
                              <div class="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div class="market-runners">
                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer1 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b1Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 1
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus1"
                                                style={{ float: "left" }}
                                              >
                                                {book1 !== "" ? (
                                                  Number(book1) > 0 ? (
                                                    <font color="green">
                                                      {" "}
                                                      {formatTruncate(book1)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {" "}
                                                      {formatTruncate(book1)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${isSuspended ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 1"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 1", b1)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        isSuspended
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b1}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer2 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b2Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 2
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus2"
                                                style={{ float: "left" }}
                                              >
                                                {book2 !== "" ? (
                                                  Number(book2) > 0 ? (
                                                    <font color="green">
                                                      {" "}
                                                      {formatTruncate(book2)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {formatTruncate(book2)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${suspend2 == 1 && b2 == 0 ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 2"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 2", b2)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        suspend2 == 1 && b2 == 0
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b2}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer3 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b3Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 3
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus3"
                                                style={{ float: "left" }}
                                              >
                                                {book3 !== "" ? (
                                                  Number(book3) > 0 ? (
                                                    <font color="green">
                                                      {formatTruncate(book3)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {formatTruncate(book3)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${suspend3 == 1 && b3 == 0 ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 3"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 3", b3)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        suspend3 == 1 && b3 == 0
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b3}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer4 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b4Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 4
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus4"
                                                style={{ float: "left" }}
                                              >
                                                {book4 !== "" ? (
                                                  Number(book4) > 0 ? (
                                                    <font color="green">
                                                      {formatTruncate(book4)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {formatTruncate(book4)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${suspend4 == 1 && b4 == 0 ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 4"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 4", b4)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        suspend4 == 1 && b4 == 0
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b4}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer5 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b5Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 5
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus5"
                                                style={{ float: "left" }}
                                              >
                                                {book5 !== "" ? (
                                                  Number(book5) > 0 ? (
                                                    <font color="green">
                                                      {formatTruncate(book5)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {formatTruncate(book5)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${suspend5 == 1 && b5 == 0 ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 5"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 5", b5)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        suspend5 == 1 && b5 == 0
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b5}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>

                              <div class="runner-runner">
                                <h3
                                  className={
                                    winnerplayer6 && cardsSettled
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                  id="b6Sucess"
                                >
                                  <div class="runner-info">
                                    <span class="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: "0px",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                                class="clippable-spacer"
                                              >
                                                Player 6
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                id="bstatus6"
                                                style={{ float: "left" }}
                                              >
                                                {book6 !== "" ? (
                                                  Number(book6) > 0 ? (
                                                    <font color="green">
                                                      {formatTruncate(book6)}
                                                    </font>
                                                  ) : (
                                                    <font color="red">
                                                      {formatTruncate(book6)}
                                                    </font>
                                                  )
                                                ) : (
                                                  ""
                                                )}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>

                                <div class="price-row-box-new">
                                  <div
                                    className={`runner-disabled2 suspendCls ${suspend6 == 1 && b6 == 0 ? "" : "hides"
                                      }`}
                                  >
                                    {suspendedText}
                                  </div>
                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    class="price-price price-back mb-show span3details"
                                    data-teamname="Player 6"
                                    data-market-type="m"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip("b", "Player 6", b6)
                                    }
                                  >
                                    <div
                                      id="rnr1"
                                      className={
                                        suspend6 == 1 && b6 == 0
                                          ? "sus_cls suspended"
                                          : "sus_cls"
                                      }
                                    >
                                      <span
                                        class="price-odd odd"
                                        id="runnerdragonspan"
                                      >
                                        {b6}
                                      </span>
                                      <span class="price-amount" id="rate1">
                                        {stakeLimit}
                                      </span>
                                    </div>
                                  </a>

                                  <a class="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>

                                  <a class="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <HighCardResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-12 col-md-4 mobile-margin">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets ({totalBets})
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table
                              className="table"
                              style={{ marginBottom: 0 }}
                            >
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {betList.length > 0
                                  ? betList.map((item, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          item.type === "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4",
                                        color: "#000",
                                        fontSize: "15px",
                                        textAlign: "center"
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "5px"
                                        }}
                                      >
                                        {item.rnr === "b1" ||
                                          item.rnr === "l1"
                                          ? "Player 1"
                                          : item.rnr === "b2" ||
                                            item.rnr === "l2"
                                            ? "Player 2"
                                            : item.rnr === "b3" ||
                                              item.rnr === "l3"
                                              ? "Player 3"
                                              : item.rnr === "b4" ||
                                                item.rnr === "l4"
                                                ? "Player 4"
                                                : item.rnr === "b5" ||
                                                  item.rnr === "l5"
                                                  ? "Player 5"
                                                  : item.rnr === "b6" ||
                                                    item.rnr === "l6"
                                                    ? "Player 6"
                                                    : item.rnr}{" "}
                                        - ({item.cat_mid})
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "5px"
                                        }}
                                      >
                                        {item.rate}
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "5px"
                                        }}
                                      >
                                        {item.amnt}
                                      </td>
                                      <td></td>
                                    </tr>
                                  ))
                                  : ""}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
          .highcard-virtual-scope {
            --highcard-body-width: 80px;
            --highcard-body-height: 100px;
            --highcard-inner-width: 64px;
            --highcard-inner-height: 80px;
            --highcard-card-width: var(--highcard-body-width);
            --highcard-card-height: var(--highcard-body-height);
            --highcard-card-aspect: 4 / 5;
          }
          .highcard-virtual-scope .highcard-gradient {
            position: relative;
            background: transparent;
            overflow: hidden;
          }
          .highcard-virtual-scope .highcard-players-stage.highcard-gradient {
            overflow: visible;
            background: transparent;
          }

          .highcard-virtual-scope .highcard-gradient > * {
            position: relative;
            z-index: 1;
          }

          .highcard-virtual-scope .cards-layout.blackjack {
            position: relative;
            background: #000000 !important;
          }

          .highcard-virtual-scope .cards-layout.blackjack::before {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background: radial-gradient(
              ellipse 100% 44% at 50% calc(30% + 80px),
              rgba(62, 193, 65, 0.95) 0%,
              rgba(62, 193, 65, 0.8) 15%,
              rgba(30, 80, 35, 0.5) 40%,
              #1e1e1e 55%,
              #1e1e1e 100%
            );
            opacity: 0.4;
            pointer-events: none;
            z-index: 0;
          }

          .highcard-virtual-scope .cards-layout.blackjack > * {
            position: relative;
            z-index: 1;
          }

          .highcard-virtual-scope .cards-layout.blackjack > .timerDiv2 {
            z-index: 10;
          }

          .highcard-virtual-scope .timerDiv2 .Connectedclients,
          .highcard-virtual-scope .timerDiv2 .teenpatti-base-timer {
            position: relative;
            z-index: 11;
          }

          .highcard-virtual-scope .blackjack {
            background: #000000 !important;
          }

          .highcard-virtual-scope .player-scope .player-card,
          .highcard-virtual-scope .player-scope .player-card.stood,
          .highcard-virtual-scope .player-scope .player-card.won,
          .highcard-virtual-scope .highcard-players-stage .player-card,
          .highcard-virtual-scope .highcard-players-stage .player-card.stood,
          .highcard-virtual-scope .highcard-players-stage .player-card.won {
            background: rgba(255, 255, 255, 0.3) !important;
            background-image: none !important;
            backdrop-filter: none !important;
          }

         .player {
            margin: 4px;
            display: inline-block;
            justify-content: space-between;
            flex: 1 0 0;
            flex-wrap: wrap;
          }
          .highcard-virtual-scope .highcard-players-stage {
            display: grid !important;
            border: none !important;
            margin-top: -20px;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            grid-auto-rows: auto;
            column-gap: 10px;
            row-gap: 10px;
            width: 100%;
            max-width: min(100%, calc(var(--highcard-card-width) * 3 + 20px + 16px));
            margin-left: auto;
            margin-right: auto;
            justify-content: center;
            justify-items: center;
            align-items: start;
            height: auto !important;
            min-height: calc(var(--highcard-card-height) * 2 + 48px);
            overflow: visible;
            padding: 14px 8px 18px;
            box-sizing: border-box;
          }
          .highcard-virtual-scope .highcard-players-stage.desktop,
          .highcard-virtual-scope .highcard-players-stage.mobile {
            height: auto !important;
          }
          .highcard-virtual-scope .highcard-players-stage > .player {
            flex: unset !important;
            width: auto;
            max-width: var(--highcard-card-width);
            min-width: 0;
            display: flex !important;
            justify-content: center;
            box-sizing: border-box;
            padding: 0;
            margin: 0 !important;
            overflow: visible;
          }
          .highcard-virtual-scope .highcard-players-stage .player-item {
            width: auto;
            max-width: var(--highcard-card-width);
            min-width: 0;
            margin: 0 !important;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
          }
          .highcard-virtual-scope .highcard-players-stage .player-item .name {
            display: block;
            color: #d7bc7b !important;
            text-align: center;
            font-size: 13px;
            font-weight: 700;
            line-height: 1.2;
            margin: 0;
            white-space: nowrap;
          }
          .highcard-virtual-scope .highcard-players-stage .player-card {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            overflow: hidden !important;
            margin: 0 !important;
            box-sizing: border-box;
            flex-shrink: 0;
            width: var(--highcard-body-width) !important;
            max-width: var(--highcard-body-width);
            min-width: var(--highcard-body-width);
            height: var(--highcard-body-height) !important;
            aspect-ratio: var(--highcard-card-aspect);
            padding: 0 !important;
            border-radius: 13px;
          }
          .highcard-virtual-scope .highcard-players-stage .player-card .header-title {
            display: none;
          }
          .highcard-virtual-scope .highcard-players-stage .BFBCardHandView {
            position: relative !important;
            width: var(--highcard-inner-width) !important;
            height: var(--highcard-inner-height) !important;
            max-width: var(--highcard-inner-width) !important;
            max-height: var(--highcard-inner-height) !important;
            aspect-ratio: var(--highcard-card-aspect);
            margin: 0 auto !important;
            overflow: hidden;
            flex-shrink: 0;
          }
          .highcard-virtual-scope .highcard-players-stage .BFBCardFanView {
            position: relative !important;
            width: 100% !important;
            height: 100% !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .highcard-virtual-scope .highcard-players-stage .card1,
          .highcard-virtual-scope .highcard-players-stage #BFBCardView,
          .highcard-virtual-scope .highcard-players-stage #BFBCardView2 {
            position: relative !important;
            left: auto !important;
            top: auto !important;
            transform: none !important;
            width: 100% !important;
            height: 100% !important;
            margin: 0 auto !important;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .highcard-virtual-scope .highcard-players-stage .RSMImageView {
            position: relative !important;
            left: auto !important;
            top: auto !important;
            width: 100% !important;
            height: 100% !important;
            max-width: 100%;
            max-height: 100%;
            display: block;
            margin: 0 auto;
            object-fit: contain;
          }
          .highcard-virtual-scope .three-cards-wrapper {
            overflow: visible;
            margin-top: 6px;
            width: 100%;
          }
          .highcard-virtual-scope .timerDiv2.mb-negative-24 {
            margin-bottom: -18px;
          }
          .player-item {
            margin-bottom: 16px;
            display: block;
            margin-right: 0;
            z-index: 0;
          }
          .player-item .name {
            display: block;
            color: #d7bc7b !important;
            font-size: 14px;
            font-weight: 700;
            text-align: center;
          }
          .player-item .player-cards {
            border-radius: 12px;
            border: 1px solid rgba(178, 220, 175, .25);
          }
          .highcard-virtual-scope .ExMainCardbundle .BFBCardHandView {
            transform: translate3d(0, 0, 0);
            width: var(--highcard-inner-width);
            height: var(--highcard-inner-height);
            aspect-ratio: var(--highcard-card-aspect);
            margin-top: 5px;
            margin-bottom: 5px;
          }
          #refreshhistory .table thead th {
            padding: 5px;
            color: #2b2f35;
            background: #ddd;
          }
          .video-button {
            background-color: #4f4f4f;
            color: #fff;
            font-family: 'Roboto Condensed';
            font-size: 11px;
            font-style: normal;
            font-weight: 500;
            height: 35px;
            margin-right: 3px;
            text-align: center;
            width: 40px;
            pointer-events: none;
          }
          @media screen and (max-width: 576px) {
            .highcard-virtual-scope .video-button {
              margin-right: 1px;
              width: 37px;
            }
          }
          .Connectedclients {
            opacity: 0.9;
            position: absolute;
            z-index: 1000;
            float: inline-start;
            width: auto;
            display: flex;
            align-items: center;
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(8px);
            padding: 0px 8px;
            border-radius: 15px;
            border-right: 1px solid white;
            border-bottom: 1px solid white;
          }
          #bookmakerExample .btn-block{
            padding:1px;
          }
          .highcard-virtual-scope .BFBCardHandView {
            transform: translate3d(0, 0, 0);
            width: var(--highcard-inner-width);
            height: var(--highcard-inner-height);
            aspect-ratio: var(--highcard-card-aspect);
          }
          .mb-negative-24 {
            margin-bottom: -45px;
          }
          .highcard-virtual-scope .player-scope .player-card {
            border: 1px solid rgba(173, 172, 172, 0.5);
            justify-content: center;
            width: var(--highcard-body-width);
            height: var(--highcard-body-height);
            aspect-ratio: var(--highcard-card-aspect);
            border-radius: 13px;
            padding: 0;
          }
          @media (min-width: 992px) {
            .highcard-virtual-scope .cards-layout.blackjack {
              min-height: calc(var(--highcard-card-height) * 2 + 80px);
            }
            .highcard-virtual-scope .highcard-players-stage {
              min-height: calc(var(--highcard-card-height) * 2 + 56px);
              max-width: min(100%, calc(var(--highcard-card-width) * 3 + 20px + 24px));
              padding: 16px 12px 20px;
            }
          }
          @media (min-width: 1200px) {
            .highcard-virtual-scope .cards-layout.blackjack {
              min-height: calc(var(--highcard-body-height) * 1.2 + 72px);
            }
            .highcard-virtual-scope .highcard-players-stage {
              grid-template-columns: repeat(6, calc(var(--highcard-body-width) * 1.2));
              grid-auto-rows: auto;
              column-gap: 10px;
              row-gap: 0;
              width: auto;
              max-width: min(100%, calc(var(--highcard-body-width) * 1.2 * 6 + 50px + 24px));
              margin-left: auto;
              margin-right: auto;
              min-height: calc(var(--highcard-body-height) * 1.2 + 40px);
              padding: 10px 12px 14px;
              justify-content: center;
              justify-items: center;
            }
            .highcard-virtual-scope .highcard-players-stage > .player {
              width: calc(var(--highcard-body-width) * 1.2);
              max-width: calc(var(--highcard-body-width) * 1.2);
              min-width: calc(var(--highcard-body-width) * 1.2);
              justify-content: center;
            }
            .highcard-virtual-scope .highcard-players-stage .player-item {
              width: calc(var(--highcard-body-width) * 1.2);
              max-width: calc(var(--highcard-body-width) * 1.2);
              min-width: calc(var(--highcard-body-width) * 1.2);
              gap: 6px;
              align-items: center;
            }
            .highcard-virtual-scope .highcard-players-stage .player-item .name {
              font-size: 14px;
            }
            .highcard-virtual-scope .highcard-players-stage .player-card {
              width: calc(var(--highcard-body-width) * 1.2) !important;
              max-width: calc(var(--highcard-body-width) * 1.2) !important;
              min-width: calc(var(--highcard-body-width) * 1.2) !important;
              height: calc(var(--highcard-body-height) * 1.2) !important;
              max-height: calc(var(--highcard-body-height) * 1.2) !important;
              min-height: calc(var(--highcard-body-height) * 1.2) !important;
              aspect-ratio: auto;
              padding: 0 !important;
              flex-shrink: 0;
              background: rgba(255, 255, 255, 0.3) !important;
              background-image: none !important;
              backdrop-filter: none !important;
              border: 1px solid rgba(173, 172, 172, 0.5);
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
            }
            .highcard-virtual-scope .highcard-players-stage .BFBCardHandView {
              width: calc(var(--highcard-inner-width) * 1.2) !important;
              height: calc(var(--highcard-inner-height) * 1.2) !important;
              max-width: calc(var(--highcard-inner-width) * 1.2) !important;
              max-height: calc(var(--highcard-inner-height) * 1.2) !important;
              min-width: calc(var(--highcard-inner-width) * 1.2) !important;
              min-height: calc(var(--highcard-inner-height) * 1.2) !important;
              aspect-ratio: auto;
            }
            .highcard-virtual-scope .highcard-players-stage .BFBCardFanView,
            .highcard-virtual-scope .highcard-players-stage .card1,
            .highcard-virtual-scope .highcard-players-stage #BFBCardView,
            .highcard-virtual-scope .highcard-players-stage #BFBCardView2 {
              width: 100% !important;
              height: 100% !important;
              max-width: 100% !important;
              max-height: 100% !important;
            }
            .highcard-virtual-scope .highcard-players-stage .RSMImageView {
              width: 100% !important;
              height: 100% !important;
              max-width: 100% !important;
              max-height: 100% !important;
              object-fit: contain;
            }
          }
          @media (min-width: 768px) {
            .highcard-virtual-scope .timerDiv2 .teenpatti-base-timer {
              top: -30px;
            }
            .highcard-virtual-scope .cards-layout.blackjack .sound-icon {
              right: 18px !important;
              transform: scale(0.9);
              transform-origin: center;
            }
          }
          @media (max-width: 767.98px) {
            .highcard-virtual-scope .home-content {
              margin-top: 0 !important;
            }
            .highcard-virtual-scope .highcard-game-row {
              flex-direction: column;
              width: 100%;
              margin-left: 0;
              margin-right: 0;
            }
            .highcard-virtual-scope .highcard-game-row > .col-md-8,
            .highcard-virtual-scope .highcard-game-row > .col-md-4 {
              flex: 0 0 100%;
              max-width: 100%;
              width: 100%;
              padding-left: 0 !important;
              padding-right: 0 !important;
            }
            .highcard-virtual-scope .left-content,
            .highcard-virtual-scope .highcard-market-board {
              width: 100%;
              padding-left: 0 !important;
              padding-right: 0 !important;
              box-sizing: border-box;
            }
            .highcard-virtual-scope .timerDiv2 .teenpatti-base-timer {
              top: -20px;
            }
            .highcard-virtual-scope .cards-layout.blackjack label.sound-icon[for="HighCardSoundcontrol"] {
              transform: scale(0.76);
              transform-origin: bottom right;
              right: 18px !important;
              bottom: -33px !important;
            }
          }
          @media (max-width: 576px) {
            .highcard-virtual-scope .highcard-players-stage {
              column-gap: 10px;
              row-gap: 10px;
              padding: 12px 6px 16px;
            }
          }
          @media (max-width: 767.98px) {
            .highcard-virtual-scope .highcard-market-board .market-titlebar {
              display: grid !important;
              grid-template-columns: minmax(0, 1fr) 64px 64px;
              column-gap: 2px;
              align-items: end;
              width: 100%;
              height: auto;
              min-height: 24px;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-name {
              grid-column: 1;
              grid-row: 1;
              min-width: 0;
              flex: unset !important;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround {
              grid-column: 2;
              grid-row: 1;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround-lay {
              grid-column: 3;
              grid-row: 1;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround,
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround-lay {
              width: 64px !important;
              min-width: 64px !important;
              max-width: 64px !important;
              margin: 0 !important;
              text-align: center;
              justify-content: center !important;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround span {
              display: none !important;
            }
            .highcard-virtual-scope .highcard-market-board .market-titlebar .market-overarround strong {
              width: 100% !important;
              font-size: 16px !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner {
              display: grid !important;
              grid-template-columns: minmax(0, 1fr) 64px 64px;
              column-gap: 2px;
              align-items: stretch;
              width: 100%;
              height: auto;
              min-height: 50px;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .runner-name {
              grid-column: 1;
              grid-row: 1;
              display: flex !important;
              min-width: 0;
              padding-left: 4px;
              flex: unset !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .runner-info {
              position: static !important;
              left: auto !important;
              top: auto !important;
              height: auto !important;
              max-width: 100% !important;
              padding-top: 4px;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new {
              grid-column: 2 / 4;
              grid-row: 1;
              display: grid !important;
              grid-template-columns: 64px 64px;
              column-gap: 2px;
              position: relative;
              width: 130px !important;
              max-width: 130px !important;
              min-width: 130px !important;
              margin: 0 !important;
              flex: unset !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price {
              display: none !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price.mb-show {
              display: flex !important;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 64px !important;
              max-width: 64px !important;
              min-width: 64px !important;
              height: 50px !important;
              flex: 0 0 64px !important;
              margin: 0 !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price.price-back.mb-show {
              grid-column: 1;
              grid-row: 1;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price.price-lay.mb-show {
              grid-column: 2;
              grid-row: 1;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-odd {
              font-size: 16px;
              line-height: 1.1;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-amount {
              font-size: 10px;
              line-height: 1.1;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price.ml-4,
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .price-price.mr-4 {
              margin-left: 0 !important;
              margin-right: 0 !important;
            }
            .highcard-virtual-scope .highcard-market-board .runner-runner .price-row-box-new .runner-disabled2 {
              position: absolute;
              inset: 0;
              width: auto !important;
              z-index: 2;
            }
          }
          @media (max-width: 768px) {
            .video-button:nth-last-child(-n+5) {
              display: block !important;
            }
          }
        `}
      </style>
    </div>
  );
}
